import { render, staticRenderFns } from "./_CardMenus.vue?vue&type=template&id=6f9b8bee&scoped=true&"
import script from "./_CardMenus.vue?vue&type=script&lang=js&"
export * from "./_CardMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9b8bee",
  null
  
)

export default component.exports